<template>
  <div class="main-container">
    <div>
      <v-layout wrap>

        <v-flex md2 sm12 style="padding-inline-end: 20px">
          <choose-date clearable :label='$t("captainProfilePage.shiftLogs.from")' v-model="from"></choose-date>
        </v-flex>
        <v-flex md2 sm12 style="padding-inline-end: 20px">
          <choose-date clearable :label='$t("captainProfilePage.shiftLogs.to")' v-model="to"></choose-date>
        </v-flex>

        <v-flex md2 sm12>
          <v-btn color="primary" dark class="mb-2 cbtn" @click="filter()" :loading="diaload">{{ $t("captainProfilePage.shiftLogs.getData") }}</v-btn>
        </v-flex>
      </v-layout>
    </div>


    <div style="overflow-x: auto; white-space: nowrap;">
      <table class="noselect">
        <tr>

          <th v-for="(_hour, index) in 24" :key="index">
            {{ index }}:00 - {{ index == 23 ? 0 : index + 1 }}:00
          </th>
        </tr>
        <tr>

          <td v-for="(_hour, index) in 24" :key="index">
            <span >{{ getActiveUsers(index) }} </span>
          </td>
        </tr>
      </table>
    </div>
    <v-dialog v-model="diaload" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ $t("captainProfilePage.common.loadingData") }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { companyNow } from "@/util/companyTime";
import axios from "axios";
import api from "@/constants/api";
import ChooseDate from "@/components/monaco/input/ChooseDate";

export default {
  name: "ShiftLogsAvg",
  components: { ChooseDate },
  data: () => ({
    shifts: [],
    sortedShifts: [],
    from: null,
    to: null,
    diaload: false,
  }),
  computed: {
    activeArray() {
      return [
        this.$t("captainProfilePage.shiftLogs.offline"),
        this.$t("captainProfilePage.shiftLogs.online"),
      ];
    },
  },
  watch: {


  },
  mounted() {
    this.from = companyNow().format("YYYY-MM-DD");
    this.to = companyNow().format("YYYY-MM-DD");
  },
  methods: {
    filter() {
      if (moment(this.from).isAfter(moment(this.to))) {
        window.getApp.$emit("SHOW_TOAST", this.$t("captainProfilePage.shiftLogs.datesInvalid"),'red');
        return;
      }
      this.diaload = true;
      this.shifts=[];
      
      const params = new URLSearchParams();
      params.append('from', moment(this.from).format("YYYY-MM-DD"));
      params.append('to', moment(this.to).format("YYYY-MM-DD"));

      axios
        .get(this.api.ACTIONS.CAPTAIN_SHIFT_LOGS_AVG, { params })
        .then((res) => {
          this.shifts=res.data.data
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err.response.data.message || this.$t("captainProfilePage.common.errorTryLater"),'red');
          console.log(err);
        })
        .finally(() => {
          this.diaload = false;
        });
    },
    getActiveUsers(index) {
      let res = this.shifts.find(a => a.hour == index);

      return res ? res.active_users : "0.00";
    }
  },


};
</script>

<style lang="scss" scoped>
.main-container {
  float: inline-start;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  padding: 18px 25px;
  gap: 20px;

  .statuses {
    width: auto;
    height: 42px;
    float: inline-start;
    display: flex;
    flex-direction: row;
    gap: 10px;

    .status {
      padding: 13px 18px;
      font-size: 14px;
      line-height: 18px;
      text-align: center;
      float: inline-start;
      color: white;
      border-radius: 9999px;
    }
  }



  table {
    width: 100%;
    height: auto;
    float: inline-start;
    background: white;
    padding: 0;
    border-radius: 10px;
    box-shadow: 0px 0px 6px rgba($color: #000b8a, $alpha: 0.1);
    // table-layout: fixed;
    border-collapse: separate;
    border-spacing: 0;

    td,
    th,
    tr {
      border: 1px solid #c1c5d8;
      height: 45px;
      // overflow: hidden;

      .current-time-indicator {
        top: 0;
        width: 2px;
        background: #e10015;
        height: 100%;
        position: absolute;
        z-index: 18;
      }
    }

    tr:last-child td:first-child {
      border-bottom-left-radius: 10px !important;
    }

    tr:last-child td:last-child {
      border-bottom-right-radius: 10px !important;
    }

    tr:first-child th:last-child {
      border-top-right-radius: 10px !important;
    }

    tr:first-child th:first-child {
      border-top-left-radius: 10px !important;
    }

    tr:nth-child(even) {
      background-color: #f7f8fa;
    }

    td,
    th {
      padding: 14px;
      padding-inline-start: 16px;
    }

    .driver-name {
      width: 13%;
      max-width: 142px;
      min-width: 100px;
      padding: 16px;
      text-align: start;
    }

    .taxi-number {
      width: 10%;
      padding: 16px;
      max-width: 142px;
      text-align: start;
    }

    .timing-container {
      width: 100%;
      height: 100%;
      max-width: 100%;
      position: relative;
      overflow-x: overlay;

      .status {
        position: absolute;
        top: 50%;
        inset-inline-start: 0;
        transform: translateY(-50%);
        height: 12px;
        border-radius: 9999px;
        z-index: 8;
        cursor: pointer;
        transition: 0.2s;

        &.end {
          border-top-right-radius: 0px;
          border-bottom-right-radius: 0px;
        }
      }

      .times {
        width: max-content;
        height: 100%;
        position: absolute;
        top: 0;
        inset-inline-start: 0;

        .time {
          width: 184px;
          height: 100%;
          float: inline-start;
          padding: 16px 22px;
          text-align: start;
          position: relative;

          .half-hour-divider {
            height: 10px;
            width: 1px;
            background: #c1c5d8;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
          }

          &:not(:last-child) {
            border-inline-end: 1px solid #c1c5d8;
          }
        }
      }

      &::-webkit-scrollbar {
        width: 0em;
        height: 0em;
      }
    }

    .noOrders {
      p {
        width: 100%;
        text-align: center;
      }
    }
  }
}
</style>